import { colors, font, spacing } from '@chegg-ui/theme';
import styled from 'styled-components';
export var MegaMenuItemsContainer = styled.div.withConfig({
  componentId: "sc-19qqgr2-0"
})(["display:flex;flex-wrap:wrap;padding:", " ", " ", ";width:calc(36.0625rem - ", " * 2);justify-content:space-between;align-items:flex-start;background-color:", ";min-height:8.0625rem;& > span{width:49%;}"], spacing.px16, spacing.px24, spacing.px32, spacing.px24, colors.white);
export var MegaMenuIconWrapper = styled.span.withConfig({
  componentId: "sc-19qqgr2-1"
})(["color:", ";padding-right:", ";& > svg{width:2.2rem;height:2.2rem;}"], colors.cheggOrange, spacing.px4); // TODO review non fanta color

export var MegaMenuBadge = styled.span.withConfig({
  componentId: "sc-19qqgr2-2"
})(["color:", ";background-color:#0091ff;font-size:0.55rem;font-weight:", ";vertical-align:top;padding:0.0625rem 0.3125rem 0;border-radius:5px;display:inline-block;"], colors.white, font.weight.bold);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-me-components/header/dist/esm/internals/CSPOnboarding/MegaMenu/styles.js
// module id = 1632
// module chunks = 11